import script from "./alarmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./alarmModal.vue?vue&type=script&setup=true&lang=js"

import "./alarmModal.vue?vue&type=style&index=0&id=6af02990&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af02990"]])

export default __exports__